import React from 'react';
import { smartCaseNode } from '../utils/smartCase';
import './DeliveryTabs.css';

/**
 * DeliveryTabs Component
 * 
 * Folder-like tab navigation for the delivery form with Who/How/What structure.
 * Color-coded tabs that always show their distinct colors:
 * - Who = Lime Green (#8BC34A)
 * - How = Orange (#FF9800)  
 * - What = Purple (#9C27B0)
 */
const DeliveryTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'what', label: 'What', color: 'purple', borderColor: '#9C27B0' },
    { id: 'who', label: 'Who', color: 'green', borderColor: '#8BC34A' },
    { id: 'how', label: 'How', color: 'orange', borderColor: '#FF9800' }
  ];

  // Get the border color for the active tab
  const activeTabData = tabs.find(t => t.id === activeTab);
  const activeBorderColor = activeTabData?.borderColor || '#8BC34A';

  return (
    <>
      <div className="delivery-tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`delivery-tab delivery-tab-${tab.color} ${
              activeTab === tab.id ? 'delivery-tab-active' : ''
            }`}
            onClick={() => onTabChange(tab.id)}
            type="button"
          >
            {smartCaseNode(tab.label)}
          </button>
        ))}
      </div>
      {/* CSS variable for dynamic border color */}
      <style>{`
        .delivery-tab-content {
          --active-tab-color: ${activeBorderColor};
        }
      `}</style>
    </>
  );
};

export default DeliveryTabs;

